import React, { useMemo } from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductRating,
  ProductImage,
  PodSection
} from '@thd-olt-component-react/product-pod';
import { Price } from '@thd-olt-component-react/price';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { createTheme, ThemeProvider } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { string, number, bool, oneOf } = proptypes;

const CustomProductPod = ({
  itemId = '',
  productIndex = 1,
  storeId = '8119',
  scheme = '',
  theme = '',
  channel = 'DESKTOP',
  enableRoundedProductImages = false,
}) => {
  const isMobile = channel === 'MOBILE';
  const analyticsData = {
    parent: 'recs-product-pod-carousel',
    position: productIndex,
    scheme
  };

  const merchRec = useMemo(() => {
    return `MERCH=REC-_-${scheme}-_-n/a-_-${productIndex}-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a`;
  }, [scheme]);

  const productRatingTheme = createTheme({
    palette: {
      mode: 'light',
      text: {
        primary: 'inverse',
        subtle: '191 191 191'
      }
    }
  });

  return (
    <div className="sui-bg-primary sui-text-primary">
      <ProductPod
        itemId={itemId}
        analyticsData={analyticsData}
        storeId={storeId}
        gap="sui-gap-0"
        padding="sui-p-0"
        render={(pod) => (
          <>
            <ProductImage
              itemId={pod.itemId}
              showSecondaryImage={pod.showSecondaryImage}
              onClick={() => {}}
              merchQueryParam={merchRec}
              enableRoundedProductImages={enableRoundedProductImages}
            />
            <PodSection columnAlign alignTop gap="sui-gap-0" className="sui-p-0">
              <ProductHeader
                brand="inline"
                itemId={pod.itemId}
                brandTitleMaxLine={isMobile ? 3 : 2}
                merchQueryParam={merchRec}
              />
              {theme === 'EndcapBFTheme'
                ? (
                  <ThemeProvider theme={productRatingTheme}>
                    <ProductRating itemId={pod.itemId} merchQueryParam={merchRec} onlyReviewCount />
                  </ThemeProvider>
                )
                : (<ProductRating itemId={pod.itemId} merchQueryParam={merchRec} onlyReviewCount />)}

              <div className="sui-mt-4">
                <Price
                  itemId={pod.itemId}
                  large={false}
                  storeId={pod.storeId}
                  displayEachUom={false}
                  onSavingsCenterToggle={pod.onSavingsCenterToggle}
                  hideForProductTypes={['HDQC']}
                  stackWasPrice
                  displayDarkTheme={theme === 'EndcapBFTheme'}
                />
              </div>
            </PodSection>
          </>
        )}
      />
    </div>
  );
};

CustomProductPod.propTypes = {
  itemId: string,
  productIndex: number,
  storeId: string,
  scheme: string,
  theme: string,
  channel: oneOf(['DESKTOP', 'MOBILE']),
  enableRoundedProductImages: bool,
};

CustomProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  Price,
  ProductRating,
  ProductHeader
);

export { CustomProductPod };
